<template>
    <b-container class="question-type4">
        <b-modal id="confirm-submit-record" hide-footer centered>
            <template #modal-title>
                <h6>Xác nhận</h6>
            </template>
            <div class="d-block text-center">
                <div class="alert alert-warning" role="alert">
                    <p class="mb-1">Bạn chắc chắn muốn nộp bản ghi âm này?</p>
                    <p class="">Khi đã nộp bài, bạn sẽ không thể chỉnh sửa câu trả lời của mình nữa.</p>
                </div>
                <div>
                    <b-button class="mx-3" variant="secondary" block @click="$bvModal.hide('confirm-submit-record')">Hủy</b-button>
                    <b-button class="mx-3" variant="primary" block @click="submitRecord">Xác nhận</b-button>
                </div>
            </div>
        </b-modal>

        <b-modal id="audio-upload-confirm" hide-footer centered size="lg">
            <template #modal-title>
                <h6>{{ jsonParse(questions.content).title }}</h6>
            </template>
            <div class="d-block text-center">
                <div class="mb-4">
                    <p style="max-width: 100%;word-break: break-all;"><span>Tập tin đã chọn:</span> {{ fileAudioUpload?.name }}</p>
                    <audio controls="true" class="mw-100" :src="createObjectUrl(fileAudioUpload)"></audio>
                </div>
                <div class="d-flex justify-content-end w-100">
                    <b-button class="mx-3 m-0" variant="secondary" block @click="$bvModal.hide('audio-upload-confirm')">Hủy</b-button>
                    <b-button class="mx-3 m-0" variant="primary" block @click="submitUploadRecord(jsonParse(questions.content).title)">Nộp và chuyển câu tiếp</b-button>
                </div>
            </div>
        </b-modal>

        <b-row v-if="step == 1">
            <div class="w-100 h3 text-center py-5" v-html="content.description"></div>
        </b-row>
        <b-row :class="{'d-none': step == 1}" class="justify-content-center">
            <div class="item_quesion w-100">
                <div class="header_question text-center">
                    <h2>{{ jsonParse(questions.content).title }}</h2>
                </div>
                
                <div class="image-block" v-if="checkFileTypeWithFileName(jsonParse(questions.content).file) == 'image'">
                    <div class='text-center w-100 mb-2'>
                        <img class="w-100" :src="$TestApp.getAssetBlob(jsonParse(questions.content).file)"/>
                    </div>
                    <div v-if="!hideControl" class="d-flex flex-column justify-content-center align-items-center w-100">

                        <div v-if="!recordTrack" class="d-flex flex-column">
                            <b-button @click="startRecord" v-if="!isRecord && !introVideo" pill variant="danger" class="my-2">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                                    <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                                    <line x1="12" y1="19" x2="12" y2="23"></line>
                                    <line x1="8" y1="23" x2="16" y2="23"></line>
                                </svg>
                                Ghi âm câu trả lời
                            </b-button>
                            <b-button v-if="!isRecord" @click="skipQuestion" pill variant="warning" class="my-2">
                                Bỏ qua câu hỏi này
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                            </b-button>
                        </div>

                        <div v-if="isRecord" class="d-flex flex-column">
                            <b-button @click="stopRecord" v-if="isRecord" pill variant="warning" class="my-2">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                                    <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                                    <line x1="12" y1="19" x2="12" y2="23"></line>
                                    <line x1="8" y1="23" x2="16" y2="23"></line>
                                </svg>
                                Dừng ghi âm ({{ second2Minute(timeDuration) }})
                            </b-button>
                        </div>

                        <div v-if="recordTrack" class="d-flex flex-column">
                            <b-button @click="recordReplayStop" v-if="audioReplayPlaying" pill variant="secondary" class="my-2">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                                    <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                                </svg>
                                Dừng ({{ second2Minute(audioReplayDurationTime) }})
                            </b-button>
                            <b-button @click="recordReplayPlay" v-if="!audioReplayPlaying" pill variant="secondary" class="my-2">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                                    <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                                </svg>
                                Nghe lại ({{ second2Minute(timeDuration) }})
                            </b-button>
                            <b-button @click="recordDownload(jsonParse(questions.content).title)" v-if="!audioReplayPlaying" pill variant="secondary" class="my-2">
                                <svg fill="#ffffff" height="24px" width="24px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 471.2 471.2" xml:space="preserve" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M457.7,230.15c-7.5,0-13.5,6-13.5,13.5v122.8c0,33.4-27.2,60.5-60.5,60.5H87.5c-33.4,0-60.5-27.2-60.5-60.5v-124.8 c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v124.8c0,48.3,39.3,87.5,87.5,87.5h296.2c48.3,0,87.5-39.3,87.5-87.5v-122.8 C471.2,236.25,465.2,230.15,457.7,230.15z"></path> <path d="M226.1,346.75c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.8-85.8c5.3-5.3,5.3-13.8,0-19.1c-5.3-5.3-13.8-5.3-19.1,0l-62.7,62.8 V30.75c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v273.9l-62.8-62.8c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 L226.1,346.75z"></path> </g> </g> </g></svg>
                                Tải xuống
                            </b-button>
                            <b-button @click="removeAllRecord" pill variant="danger" class="my-2">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                    <polyline points="3 6 5 6 21 6"></polyline>
                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                    <line x1="10" y1="11" x2="10" y2="17"></line>
                                    <line x1="14" y1="11" x2="14" y2="17"></line>
                                </svg>
                                Xóa bản ghi âm này
                            </b-button>
                            <b-button @click="submitRecordAction" pill variant="success" class="my-2">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                    <path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path>
                                    <polygon points="12 15 17 21 7 21 12 15"></polygon>
                                </svg>
                                Nộp bản ghi âm này
                            </b-button>
                        </div>
                    </div>
                </div>
                <div class="video-block" v-if="checkFileTypeWithFileName(jsonParse(questions.content).file) == 'video'">
                    <video disablePictureInPicture :key="questions.id" ref="video-play" class="mw-100" id="video-play">
                        <source :src="$TestApp.getAssetBlob(jsonParse(questions.content).file)" type="video/mp4">
                    </video>
                    <div class="video-time">
                        <span>{{ second2Minute(videoCurrentTime) }} / {{ second2Minute(videoDurationTime) }}</span>
                    </div>
                    <div v-if="!hideControl" class="controller-block d-flex flex-column justify-content-center align-items-center w-100">

                        <div v-if="!recordTrack" class="d-flex flex-column">
                            <b-button :disabled="videoReplayCount == 0" v-if="!isRecord" @click="videoPlay" pill variant="primary" class="my-2">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                    <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect>
                                    <line x1="7" y1="2" x2="7" y2="22"></line>
                                    <line x1="17" y1="2" x2="17" y2="22"></line>
                                    <line x1="2" y1="12" x2="22" y2="12"></line>
                                    <line x1="2" y1="7" x2="7" y2="7"></line>
                                    <line x1="2" y1="17" x2="7" y2="17"></line>
                                    <line x1="17" y1="17" x2="22" y2="17"></line>
                                    <line x1="17" y1="7" x2="22" y2="7"></line>
                                </svg>
                                Xem video ({{ videoReplayCount }})
                            </b-button>
                            <b-button @click="startRecord" v-if="!isRecord && !introVideo" pill variant="danger" class="my-2">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                                    <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                                    <line x1="12" y1="19" x2="12" y2="23"></line>
                                    <line x1="8" y1="23" x2="16" y2="23"></line>
                                </svg>
                                Ghi âm câu trả lời
                            </b-button>
                            <b-button @click="uploadRecordAudio" v-if="!isRecord && !introVideo" pill variant="secondary" class="my-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" stroke="currentColor" stroke-width="0" fill="#fff" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                                    <path d="M12 5c3.453 0 5.891 2.797 5.567 6.78 1.745-.046 4.433.751 4.433 3.72 0 1.93-1.57 3.5-3.5 3.5h-13c-1.93 0-3.5-1.57-3.5-3.5 0-2.797 2.479-3.833 4.433-3.72-.167-4.218 2.208-6.78 5.567-6.78zm0-2c-4.006 0-7.267 3.141-7.479 7.092-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408-.212-3.951-3.473-7.092-7.479-7.092zm4 10h-3v4h-2v-4h-3l4-4 4 4z"/>
                                </svg>
                                Tải lên câu trả lời
                            </b-button>
                            <b-button v-if="!isRecord" @click="skipQuestion" pill variant="warning" class="my-2">
                                Bỏ qua câu hỏi này
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                            </b-button>
                        </div>

                        <div v-if="isRecord" class="d-flex flex-column">
                            <b-button @click="stopRecord" v-if="isRecord" pill variant="warning" class="my-2">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                                    <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                                    <line x1="12" y1="19" x2="12" y2="23"></line>
                                    <line x1="8" y1="23" x2="16" y2="23"></line>
                                </svg>
                                Dừng ghi âm ({{ second2Minute(timeDuration) }})
                            </b-button>
                        </div>

                        <div v-if="recordTrack" class="d-flex flex-column">
                            <b-button @click="recordReplayStop" v-if="audioReplayPlaying" pill variant="secondary" class="my-2">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                                    <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                                </svg>
                                Dừng ({{ second2Minute(audioReplayDurationTime) }})
                            </b-button>
                            <b-button @click="recordReplayPlay" v-if="!audioReplayPlaying" pill variant="secondary" class="my-2">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                                    <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                                </svg>
                                Nghe lại ({{ second2Minute(timeDuration) }})
                            </b-button>
                            <b-button @click="recordDownload(jsonParse(questions.content).title)" v-if="!audioReplayPlaying" pill variant="secondary" class="my-2">
                                <svg fill="#ffffff" height="24px" width="24px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 471.2 471.2" xml:space="preserve" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M457.7,230.15c-7.5,0-13.5,6-13.5,13.5v122.8c0,33.4-27.2,60.5-60.5,60.5H87.5c-33.4,0-60.5-27.2-60.5-60.5v-124.8 c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v124.8c0,48.3,39.3,87.5,87.5,87.5h296.2c48.3,0,87.5-39.3,87.5-87.5v-122.8 C471.2,236.25,465.2,230.15,457.7,230.15z"></path> <path d="M226.1,346.75c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.8-85.8c5.3-5.3,5.3-13.8,0-19.1c-5.3-5.3-13.8-5.3-19.1,0l-62.7,62.8 V30.75c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v273.9l-62.8-62.8c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 L226.1,346.75z"></path> </g> </g> </g></svg>
                                Tải xuống
                            </b-button>
                            <b-button @click="removeAllRecord" pill variant="danger" class="my-2">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                    <polyline points="3 6 5 6 21 6"></polyline>
                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                    <line x1="10" y1="11" x2="10" y2="17"></line>
                                    <line x1="14" y1="11" x2="14" y2="17"></line>
                                </svg>
                                Xóa bản ghi âm này
                            </b-button>
                            <b-button @click="submitRecordAction" pill variant="success" class="my-2">
                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                    <path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path>
                                    <polygon points="12 15 17 21 7 21 12 15"></polygon>
                                </svg>
                                Nộp bản ghi âm này
                            </b-button>
                        </div>

                    </div>
                </div>
                <audio ref="audio-replay" src=""></audio>
            </div>
        </b-row>
        <div class="d-flex justify-content-center pt-5" v-if="step == 1">
            <b-button @click="nextQuestion" class="btn-custom" variant="success">{{ step == 1 ? 'Start' : 'Next' }}</b-button>
        </div>
    </b-container>
</template>

<script>
/* eslint-disable */

// import AudioRecorder from '@/components/record/recorder.vue'
// import Config from '../../../config'
// import Recorder from '../lib/recorder'
// import EventBus from '../../libs/EventBus'
import moment from 'moment'

import RecordRTC from 'recordrtc'

export default {
    props: {
        content: Object
    },
    components: {
        // AudioRecorder
    },
    created() {

        if (this.content.question_index) {
            this.questionIndex = this.content.question_index
        }

        if (this.content.step) {
            this.step = this.content.step
        }

        if (this.content.video_replay) {
            this.videoReplayCount = this.content.video_replay
        }

        if (this.questionIndex == 0) {
            this.step = 1
        }

        window.EventBus.$on('TIME_UP', this.timeUpHandle)
    },
    mounted() {
        this.initRecordAudio()
    },
    methods: {
        recordDownload (fileName) {

            var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            var isChrome =
            navigator.userAgent.toLowerCase().indexOf("CriOS") > -1 ||
            navigator.vendor.toLowerCase().indexOf("google") > -1;
            var iOSVersion = [];
            if (iOS) {
            iOSVersion = navigator.userAgent
                .match(/OS [\d_]+/i)[0]
                .substr(3)
                .split("_")
                .map((n) => parseInt(n));
            }
            
            try {
                const linkElement = document.createElement("a");
                // document.body.appendChild(a);
                // a.style = "display: none";

                const url = window.URL.createObjectURL(this.recordTrack);

                linkElement.setAttribute('href', url);
                linkElement.setAttribute('target', '_blank');
                
                const attachmentName = fileName + '.mp3';

                if ((iOS && (iOSVersion[0] > 12 || isChrome)) || !iOS) {
                    linkElement.setAttribute("download", attachmentName);
                }
                var clickEvent = new MouseEvent("click", {
                    view: window,
                    bubbles: true,
                    cancelable: false
                });
                linkElement.dispatchEvent(clickEvent);
                
            } catch (error) {
                
            }

        },
        submitUploadRecord (questionTitle) {
            this.$store.commit('PAGE_LOADING', true)

            this.$bvModal.hide('audio-upload-confirm')
            this.saveRecord(this.fileAudioUpload)
            .then(() => {

                this.$bvToast.toast(`Ghi âm ${questionTitle} đang được xử lý!`, {
                    title: `Thông báo`,
                    variant: 'success',
                    solid: true
                })

                this.nextQuestion();

                this.$TestApp.testSave()
                .then(() => {
                    this.$store.commit('PAGE_LOADING', false)
                })
                .catch((err) => {
                    this.$bvToast.toast(err, {
                        title: `Có lỗi xảy ra !`,
                        variant: 'danger',
                        solid: true
                    })
                    this.$store.commit('PAGE_LOADING', false)
                } )
                
            })
        },

        uploadRecordAudio () {

            let uploadInput = document.querySelector('#record-audio-upload')

            const acceptType = 'audio/aac,audio/mpeg,audio/vnd.wave,audio/wav,audio/wave,audio/x-pn-wav,audio/x-wav,audio/x-m4a,audio/m4a,.mp3,.wav,.m4a,.aac'
            const fileSizeMegabyte = 2
            const fileSizeMax = fileSizeMegabyte * 1024 * 1024

            if (!uploadInput) {

                uploadInput = document.createElement('input')
                uploadInput.setAttribute('type', 'file')
                uploadInput.setAttribute('accept', acceptType)
                uploadInput.setAttribute('style', 'display: none;')
                
                uploadInput.addEventListener('change', event => {
                    
                    if (uploadInput.files.length) {

                        this.fileAudioUpload = uploadInput.files[0] //URL.createObjectURL(uploadInput.files[0]);
                        
                        if (!acceptType.split(',').includes(this.fileAudioUpload.type)) {
                            this.$bvModal.msgBoxOk('File không hợp lệ, hãy chọn file audio', {
                                title: 'Opps, error',
                                centered: true,
                                size: 'md'
                            })
                            return
                        }

                        if (this.fileAudioUpload.size > fileSizeMax) {
                            this.$bvModal.msgBoxOk(`File của bạn quá lớn, chúng tôi chấp nhận file < ${fileSizeMegabyte}M`, {
                                title: 'Opps, error',
                                centered: true,
                                size: 'md'
                            })

                            return
                        }

                        this.$bvModal.show('audio-upload-confirm')

                    }
                })

                document.body.appendChild(uploadInput)
            }

            uploadInput.click()

            
        },
        checkFileTypeWithFileName (filename) {
            
            if (!filename ) return '';

            let file_ext = filename.split('.').pop()

            if (!file_ext) return '';

            file_ext = file_ext.toLowerCase()

            if (['acc', 'wma', 'wav', 'mp4', 'mp3', 'flac', 'm4a'].includes(file_ext)) return 'video'
            if (['jpeg', 'jpg', 'png'].includes(file_ext)) return 'image'

        },
        async initRecordAudio () {
            var isEdge = navigator.userAgent.indexOf('Edge') !== -1 && (!!navigator.msSaveOrOpenBlob || !!navigator.msSaveBlob);
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

            return new Promise((resolve) => {
                if(typeof navigator.mediaDevices === 'undefined' || !navigator.mediaDevices.getUserMedia) {
                    alert('This browser does not supports WebRTC getUserMedia API.');

                    if(!!navigator.getUserMedia) {
                        alert('This browser seems supporting deprecated getUserMedia API.');
                    }
                }

                navigator.mediaDevices.getUserMedia({
                    audio: isEdge ? true : {
                        echoCancellation: false,
                        // sampleRate: 48000
                    },
                }).then(streamHandler => {
                    if (streamHandler.getAudioTracks().length > 0) {
                        this.recorder = this.$recordRTC(streamHandler.clone(), {
                            type: 'audio',
                            disableLogs: false,
                            mimeType: 'audio/wav',
                            numberOfAudioChannels: 2,
                            checkForInactiveTracks: true,
                            recorderType: this.$recordRTC.StereoAudioRecorder,
                            // bufferSize: 4096, 
                            // sampleRate: 48000
                        });

                        resolve()
                        
                    } else {
                        alert('Không tìm thấy mic')
                    }
                }).catch(function(error) {
                    alert('Unable to capture your microphone. Please check console logs.');
                    console.error(error);
                });



                // navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

                // navigator.getUserMedia(
                //     {audio: true},
                //     streamHandler => {
                //         if (streamHandler.getAudioTracks().length > 0) {
                //             this.recorder = RecordRTC(streamHandler, {
                //                 type: 'audio',
                //                 disableLogs: true
                //             });

                //             resolve()
                            
                //         } else {
                //             alert('Không tìm thấy mic')
                //         }
                //     },
                //     errorHandler => {
                //         if (errorHandler.name == 'NotAllowedError') {
                //             alert('Yêu cầu truy cập mic đã bị từ chối, hãy kiểm tra và thử lại')
                //         } else {
                //             alert(errorHandler)
                //             console.log(errorHandler)
                //         }
                //     }
                // )
            })            
        },
        async timeUpHandle () {
            if (this.isRecord) {
                await this.stopRecord()
                this.submitRecord()
                .then(() => {
                    this.emitEndPart()
                })
            } else {
                this.emitEndPart()
            }
        },
        emitEndPart () {
            this.$emit('end-part')
        },
        submitRecordAction() {
            this.$bvModal.show('confirm-submit-record')
        },
        submitRecord () {

            this.$bvModal.hide('confirm-submit-record')
            
            return new Promise( (resolve, reject) => {
                this.saveRecord()
                .then(() => {
                    this.$TestApp.testSave()
                    .then(() => {
                        this.nextQuestion();
                        resolve(true);
                    })
                    .catch((err) => {
                        this.$bvToast.toast(err, {
                            title: `Có lỗi xảy ra !`,
                            variant: 'danger',
                            solid: true
                        })
                        reject(err)
                    } )
                })
            })
        },
        saveRecord(audioBlob) {
            // this.$bvModal.hide('confirm-submit-record')
            // const audioBlob = this.recordTrack

            // this.recordReplayStop()
            // this.removeAllRecord()

            // return this.$TestApp.saveRecord(this.questions.id, audioBlob)

            return new Promise( (resolve, reject) => {
                if (!audioBlob) {
                    audioBlob = this.recordTrack
                }
                this.recordReplayStop()
                this.removeAllRecord()
                this.$TestApp.saveRecord(this.questions, audioBlob)

                resolve(true)
            })

        },

        recordReplayPlay() {
            const self = this;
            if (this.recordTrack) {

                this.$refs['audio-replay'].src = URL.createObjectURL(this.recordTrack)
                this.$refs['audio-replay'].load()

                this.$refs['audio-replay'].addEventListener('canplay', function () {
                    self.audioReplayPlaying = true
                    self.$refs['audio-replay'].play()
                })
                this.$refs['audio-replay'].addEventListener('ended', function () {
                    self.audioReplayPlaying = false
                })
                this.$refs['audio-replay'].addEventListener('timeupdate', function (event) {
                    self.audioReplayDurationTime = event.target.currentTime
                })
            }
        },
        recordReplayStop() {
            this.$refs['audio-replay'].pause()
            this.audioReplayPlaying = false
        },
        videoPlay() {

            if (this.videoReplayCount > 0) {
                this.$refs['video-play'].volume = 1
                this.$refs['video-play'].play()
                this.$refs['video-play'].addEventListener('ended', this.videoEndedHandle)
                this.$refs['video-play'].addEventListener('play', this.videoPlayHandle)
                this.$refs['video-play'].addEventListener('pause', this.videoEndedHandle)
                this.$refs['video-play'].addEventListener('timeupdate', this.videoTimeupdateHandle)

                this.videoReplayCount--

                this.$TestApp.setVideoPlayCouter(this.videoReplayCount)
            }
        },
        videoEndedHandle() {
            this.hideControl = false
        },
        videoTimeupdateHandle(event) {
            this.videoCurrentTime = event.target.currentTime
            this.videoDurationTime = event.target.duration
        },
        videoPlayHandle() {
            this.hideControl = true
        },
        second2Minute(seconed) {
            return moment.utc(seconed * 1000).format('mm:ss')
            return `${(seconed / 60).toFixed(0) < 10 ? '0' + (seconed / 60).toFixed(0) : (seconed / 60).toFixed(0)}: ${(seconed % 60).toFixed(0) < 10 ? '0' + (seconed % 60).toFixed(0) : (seconed % 60).toFixed(0)}`
        },
        jsonParse(string) {
            try {
                return JSON.parse(string)
            } catch (error) {
                //
            }
            return {}
        },

        startRecord() {

            this.initRecordAudio()
            .then(() => {
                this.recorder.startRecording();
                this.isRecord = true
                this.dateStarted = new Date().getTime();
                this.timeDuration = ''
                this.recordTimeCount()
            })

            // const self = this;

            // navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

            // if (typeof navigator.getUserMedia === 'undefined') {
            //     navigator.mediaDevices.getUserMedia({
            //         audio: true
            //     }).then(streamHandler => {
            //         if (streamHandler.getAudioTracks().length > 0) {
            //             self.recorder.start()
            //         } else {
            //             alert('Không tìm thấy mic')
            //         }
            //     }).catch(errorHandler => {
            //         if (errorHandler.name == 'NotAllowedError') {
            //             alert('Yêu cầu truy cập mic đã bị từ chối, hãy kiểm tra và thử lại')
            //         } else {
            //             alert(errorHandler)
            //             console.log(errorHandler)
            //         }
            //     });
            // } else {
            //     navigator.getUserMedia({
            //         audio: true
            //     }, function (stream) {
            //         if (stream.getAudioTracks().length > 0) {
            //             self.recorder.start()
            //         } else {
            //             alert('Không tìm thấy mic')
            //         }
            //     }, function (error) {
            //         if (error.name == 'NotAllowedError') {
            //             alert('Yêu cầu truy cập mic đã bị từ chối, hãy kiểm tra và thử lại')
            //         } else {
            //             alert(error)
            //             console.log(error)
            //         }
            //     });
            // }
        },
        recordTimeCount () {
            if(!this.recorder) {
                return;
            }
            this.timeDuration = (new Date().getTime() - this.dateStarted) / 1000
            setTimeout(this.recordTimeCount, 1000);
        },
        async stopRecord() {
            // this.recorder.stop()

            return new Promise ((resolve, reject) => {
                this.recorder.stopRecording(() => {
                    let blob = this.recorder.getBlob();
                    this.recordTrack = blob;
                    console.log(this.recordTrack)
                    this.recorder = null;
                    this.isRecord = false

                    resolve(true)
                    // invokeSaveAsDialog(blob);
                });
            })
        },
        removeAllRecord() {
            this.recordTrack = null;
        },

        initRecordAudio() {

            var isEdge = navigator.userAgent.indexOf('Edge') !== -1 && (!!navigator.msSaveOrOpenBlob || !!navigator.msSaveBlob);
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

            return new Promise((resolve) => {
                if(typeof navigator.mediaDevices === 'undefined' || !navigator.mediaDevices.getUserMedia) {
                    alert('This browser does not supports WebRTC getUserMedia API.');

                    if(!!navigator.getUserMedia) {
                        alert('This browser seems supporting deprecated getUserMedia API.');
                    }
                }

                navigator.mediaDevices.getUserMedia({
                    audio: isEdge ? true : {
                        echoCancellation: false
                    }
                }).then(streamHandler => {
                    if (streamHandler.getAudioTracks().length > 0) {
                        this.recorder = RecordRTC(streamHandler, {
                            type: 'audio',
                            disableLogs: false
                        });

                        resolve()
                        
                    } else {
                        alert('Không tìm thấy mic')
                    }
                }).catch(function(error) {
                    alert('Unable to capture your microphone. Please check console logs.');
                    console.error(error);
                });

            })
        },

        saveTest() {

            return new Promise((resovel, reject) => {
                const self = this
                const trackid = localStorage.getItem('_speakup_track')
                self.$http.post('/test-save-v2', {
                    trackid: trackid,
                    test_data: JSON.parse(localStorage.getItem('speakupTestData')),
                })
                .then( (response) => {
                    if (response.data.code === 1) {
                        this.$bvModal.hide('confirm-submit-record')
                        this.nextQuestion();
                        resovel(response)
                    } else {
                        this.$bvToast.toast(response.data.message, {
                            title: `Có lỗi xảy ra !`,
                            variant: 'danger',
                            solid: true
                        })
                        reject(response.data.message)
                    }
                })
            })
        },

        skipQuestion() {
            this.$bvModal.msgBoxConfirm('Bạn chắc chắn muốn bỏ qua câu hỏi này ?', {
                    title: 'Xác nhận',
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    okTitle: 'Vâng',
                    cancelTitle: 'Không',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value == true) {
                        this.nextQuestion()
                    }
                })
        },

        nextQuestion() {
            if (this.step == 1) {
                this.step = 2
                this.$TestApp.setPartStep(this.step)
                return;
            }
            if (this.questionIndex < this.content.questions.length - 1) {
                this.questionIndex++
            } else {
                //
                this.$emit('end-part')
            }

            this.removeAllRecord()
            this.videoReplayCount = 2;
            this.$TestApp.setVideoPlayCouter(this.videoReplayCount)
            this.$TestApp.setQuestionIndex(this.questionIndex)
            this.$refs['video-play'].addEventListener('canplay', this.videoReady)
        },
        createObjectUrl (file) {
            if (!file) return ''
            return URL.createObjectURL(file)
        }
    },
    computed: {
        introVideo () {
            return this.questions?.settings?.intro_video || false
        },
        recordTime() {
            return this.second2Minute(this.recorder.duration)
        },
        questions() {
            return this.content.questions[this.questionIndex]
        },
        nameFile: function () {
            return localStorage.getItem("_speakup_track") + 'ninja';
        },
    },
    watch: {},
    data() {
        return {
            isRecord: false,
            timeDuration: '',
            dateStarted: 0,
            recordTrack: '',
            array_link: [],
            upload_url: `/uploads`,
            message: '',
            mp3: '/demo/example.mp3',
            showRecorder: true,
            headers: {
                'X-Custom-Header': 'some data'
            },
            step: 1,
            questionIndex: 0,
            videoElement: null,
            hideControl: false,
            videoCurrentTime: 0,
            videoDurationTime: 0,
            videoReplayCount: 2,

            recorder: null,
            audioReplayPlaying: false,
            audioReplayDurationTime: 0,

            fileAudioUpload: null
        }
    }
}
</script>

<style scoped>
.header_question h2 {
    font-size: 25px;
    font-weight: 800;
    color: #0057a7;
}

.content_question {
    /* margin-top: 15px; */
    flex-wrap: wrap;
    justify-content: space-between;
}

.item_answer {
    /* display: flex; */
    margin-bottom: 10px;
    padding: 5px 20px;
    border-radius: 15px;
    /* display: flex; */
    align-items: center;
    color: #0057a7;
    font-weight: 600;
    transition: 0.3 ease;
}

.text_answer {
    margin-left: 10px;
}

video::-webkit-media-controls {
    display: none;
}

.controller-block {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #00000070;
}

.video-block {
    position: relative;
    min-height: 400px;
}

.video-time {
    position: absolute;
    top: 10px;
    left: 10px;
    font-weight: 700;
    font-size: 20px;
    color: #fff;
    text-shadow: 1px 1px #000000bd
}
</style>

<style>
.text_answer input {
    border: 1px solid #0057a7;
    border-radius: 12px;
    margin: 0 5px;
    height: 30px;
    padding: 0 10px;
    color: #0057a7;
}

@media only screen and (max-width: 768px) {
    .header_question h2 {
        font-size: 18px;
    }

    .header_question .title_question {
        /* font-size: 17px; */
    }

    .item_answer {
        width: 100% !important;

    }
}

@media only screen and (max-width: 500px) {
    .text_answer input {
        width: 100px;
    }
}
</style>
